import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChatCircleText, PaperPlaneTilt, UserPlus, Crown } from '@phosphor-icons/react';

/**
 * Admin-only shortcut card on event Manage pages. Jumps into the existing
 * Admin Communications composer with the right recipients preselected via
 * URL context. Builds NO recipient list and sends NOTHING itself — the
 * Bulk SMS Center owns all eligibility / suppression / dedup / history.
 */
export default function CommunicateCard({ eventKind, eventId, eventName, isAdmin, registeredCount }) {
  const navigate = useNavigate();
  if (!isAdmin || !eventId) return null;

  const go = (source) => {
    const params = new URLSearchParams({ compose: '1', event_kind: eventKind, event_id: eventId, source });
    if (eventName) params.set('event_name', eventName);
    navigate(`/admin/communications?${params.toString()}`);
  };

  return (
    <section data-testid="communicate-card" className="rounded-2xl border border-[#e3dcd1] bg-[#fbfaf8] p-5">
      <div className="flex items-center gap-2 mb-3">
        <div className="shrink-0 w-8 h-8 rounded-lg bg-[#015e3f]/10 text-[#015e3f] flex items-center justify-center">
          <ChatCircleText size={18} weight="duotone" />
        </div>
        <div className="min-w-0">
          <h2 className="font-serif text-lg text-[#013523]">Communicate</h2>
          <p className="text-xs text-[#6a766e]">Text this event's people via Admin Communications &mdash; eligibility, opt-outs, dedup &amp; history all still apply.</p>
        </div>
      </div>
      <div className="flex flex-col gap-2">
        <button
          type="button"
          data-testid="communicate-registered"
          onClick={() => go('participants')}
          className="inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl bg-[#013523] text-white text-sm font-semibold hover:bg-[#025a3a] transition-colors"
        >
          <PaperPlaneTilt size={16} weight="fill" />
          Text Registered Players{typeof registeredCount === 'number' ? ` (${registeredCount})` : ''}
        </button>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
          <button
            type="button"
            data-testid="communicate-activation"
            onClick={() => go('activation')}
            className="inline-flex items-center justify-center gap-2 px-3 py-2 rounded-xl border border-[#e3dcd1] bg-white text-[#013523] text-xs font-semibold hover:bg-[#f3f1ec] transition-colors"
          >
            <UserPlus size={15} />
            Text Players Who Need Activation
          </button>
          <button
            type="button"
            data-testid="communicate-managers"
            onClick={() => go('managers')}
            className="inline-flex items-center justify-center gap-2 px-3 py-2 rounded-xl border border-[#e3dcd1] bg-white text-[#013523] text-xs font-semibold hover:bg-[#f3f1ec] transition-colors"
          >
            <Crown size={15} />
            Text Event Managers
          </button>
        </div>
      </div>
    </section>
  );
}
